import { ALIYUN_OMS_BASE_URL } from "@/config";
import ShopType from "@/enum/ShopType";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";
import { Alert, Button, Card, Divider, Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import LoginFormMapping from "./mapping/LoginFormMapping";

interface AppKeyLoginProps {}

const AppKeyLogin: React.FC<AppKeyLoginProps> = function (props) {
    const history = useHistory();

    const [form] = Form.useForm();

    const [loading, updateLoading] = useState(false);

    const search = new URLSearchParams(history.location.search);

    const shopType = search.get("shopType") as ShopType;

    const searchMessage = search.get("message");

    const shopTypeName = ShopTypeNameMap[shopType];

    function backLogin() {
        history.push("/login");
    }

    async function handleLogin() {
        await form.validateFields();

        const loginForm = document.getElementById("loginForm") as HTMLFormElement;

        loginForm.submit();

        updateLoading(true);
    }

    useEffect(() => {
        if (!shopType) {
            history.replace("/login");
        }
    }, [shopType]);

    const title =
        shopType !== ShopType.WEBUY ? (
            <span>{shopTypeName}用户登录 - 发货易</span>
        ) : (
            <span>鲸灵、好衣库用户登录 - 发货易</span>
        );

    if (!LoginFormMapping[shopType]) {
        return null;
    }

    return (
        <div className="ec-app-key-login">
            <Card title={title} className="app-key-login-card">
                {searchMessage && (
                    <Alert showIcon={false} title={searchMessage} closable className="mb20" type="error" />
                )}

                <Form
                    form={form}
                    layout="vertical"
                    action={`${ALIYUN_OMS_BASE_URL}/platform/login/secret`}
                    method="post"
                    id="loginForm"
                >
                    {LoginFormMapping[shopType]?.items.map((item) => {
                        const { name, label, type, required, password } = item;

                        let node: React.ReactNode = "";

                        if (type === "input") {
                            if (password) {
                                node = <Input.Password name={name} />;
                            } else {
                                node = <Input name={name} />;
                            }
                        }

                        return (
                            <Form.Item name={name} label={label} rules={[{ required }]} key={name} required={false}>
                                {node}
                            </Form.Item>
                        );
                    })}

                    {LoginFormMapping[shopType].help ? (
                        <p className="text-gray">{LoginFormMapping[shopType].help}</p>
                    ) : null}

                    <Form.Item className="mt10">
                        <Button onClick={handleLogin} className="ant-btn-success" disabled={loading}>
                            立即登录
                        </Button>
                    </Form.Item>

                    <Form.Item noStyle name="platformKey" initialValue={shopType}>
                        <Input type="hidden" name="platformKey" />
                    </Form.Item>
                </Form>

                <Divider />

                <p>如果你已经在其他平台使用『发货易』，你可以：</p>

                <Button type="primary" onClick={backLogin} className="mt10">
                    通过其他电商平台账号登录
                </Button>
            </Card>
        </div>
    );
};

export default React.memo(AppKeyLogin);
